import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadLandingPage } from '@tinct/core-api-models';
import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ApiError, tinctApi } from '../../api';
import { GetLandingPagesStaticParams } from '../../endpoints/landing-pages';

export const getLandingPages = async (
  params: GetCollectionQueryParams<ReadLandingPage, GetLandingPagesStaticParams>,
): Promise<ApiCollectionResponse<ReadLandingPage>> => {
  return await tinctApi.landingPages.getLandingPages(params);
};

export const useGetLandingPages = (
  params: GetCollectionQueryParams<ReadLandingPage, GetLandingPagesStaticParams>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadLandingPage>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['landing-pages', params],
    queryFn: () => getLandingPages(params),
    ...options,
  });
